import { useContext } from 'react';
import { $, $$, StarberryComponentContext, Disclosure } from '@starberry/components';
import { Icon } from "@chakra-ui/react";
import { transparentize } from "@chakra-ui/theme-tools"

const overlayColor = () => {
    const { constants } = useContext(StarberryComponentContext);
    return (
        transparentize(constants.colors.primary, 0.4)
    )
}

// const VideoLightbox = (props) => {
    
// }


export default {
    $: 'ContentSection',
    title: $('constants.translations.videoModule.VIDEOMODULE_TITLE'),
    props: {
        px: 12,
    },
    content: [
        {
            $: 'Grid',
            props: {
                templateColumns: { base: '1fr', xl: 'repeat(3, 1fr)' },
                gap: { base: 0, xl: $('constants.globalGridGap') },
                bg: $('constants.colors.grey4'),
            },
            children: [
                {
                    $: 'GridItem',
                    props: {
                        colSpan: 1,
                    },


                    component: Disclosure,
                    props: {
                        render: () => ({ isOpen, onClose, onOpen }) => {
                                return {
                                $: 'Stack',
                                props: {
                                    direction: 'column',
                                    spacing: 0,
                                },
                                children: {
                                    $: 'WrappedLink',
                                    props: {
                                        w: '100%',
                                        h: { base: '220px', xl: '100%' },
                                        d: 'block',
                                        to: null,
                                        onClick: () => onOpen,
                                    },
                                    children: [
                                        {
                                            $: 'Lightbox',
                                            isOpen: isOpen,
                                            type: 'video',
                                            sources: ['https://www.youtube.com/watch?v=VsldvxY-nkM'],
                                        },
                                        {
                                            $: 'MotionImage',
                                            backgroundImage: true,
                                            src: 'https://via.placeholder.com/150',
                                            imgContainerProps: {
                                                whileHover: {},
                                                w: '100%',
                                                h: '100%',
                                            },
                                            imgProps: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            },
                                            props: {
                                                w: '100%',
                                                h: '100%',
                                                _after: {
                                                    content: '""',
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    w: '100%',
                                                    h: '100%',
                                                    bg: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                                                    pointerEvents: 'none',
                                                },
                                                _hover: {
                                                    _after: {
                                                        bg: () => overlayColor,
                                                    },
                                                },
                                            },
                                            content: {
                                                $: 'Box',
                                                props: {
                                                    position: 'relative',
                                                    textAlign: 'center',
                                                    p: 6,
                                                    zIndex: 5,
                                                },
                                                children: {
                                                    component: Icon,
                                                    as: $('constants.icons.videoPlay'),
                                                    fontSize: '60px',
                                                    color: $('constants.colors.primary'),
                                                },
                                            },
                                        },
                                    ],
                                },
                            }
                        },
                    },
                },
                {
                    $: 'GridItem',
                    props: {
                        colSpan: 2,
                        padding: [6,null,null,8],
                    },
                    children: {
                        $: 'Box',
                        children: [
                            {
                                $: 'H3',
                                props: {
                                    fontSize: $$('constants.body.bodySize.small',null,null,'constants.headings.headingSize.h5','constants.headings.headingSize.h4'),
                                    lineHeight: $$('constants.body.bodyLineHeight.small',null,null,'constants.headings.headingLineHeight.h5','constants.headings.headingLineHeight.h4'),
                                    marginBottom: [2,null,null,4],
                                },
                                children: 'This is the title',
                            },
                            {
                                $: 'Text',
                                props: {
                                    fontSize: $$('constants.body.bodySize.xsmall',null,null,'constants.body.bodySize.small','constants.body.bodySize.medium'),
                                    lineHeight: $$('constants.body.bodyLineHeight.xsmall',null,null,'constants.body.bodyLineHeight.small','constants.body.bodyLineHeight.medium'),
                                    marginBottom: [2,null,null,4,6],
                                },
                                children: 'When an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'},
                            {
                                $: 'Flex',
                                props: {
                                    direction: {base: 'column', lg: 'row'},
                                    fontSize: $$('constants.body.bodySize.xsmall',null,null,'constants.body.bodySize.small','constants.body.bodySize.medium'),
                                    lineHeight: $$('constants.body.bodyLineHeight.xsmall',null,null,'constants.body.bodyLineHeight.small','constants.body.bodyLineHeight.medium'),
                                },
                                children: [
                                    {
                                        $: 'WrappedLink',
                                        props: {
                                            to: 'tel:05224 648525',
                                            fontSize: 'inherit',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            marginRight: { lg: 6 },
                                            _hover: {
                                                color: $('constants.colors.primary'),
                                            },
                                        },
                                        children: [
                                            {
                                                $: 'Stack',
                                                props: {
                                                    direction: 'row',
                                                    align: 'center',
                                                    spacing: '11px',
                                                },
                                                children: [
                                                    { component: Icon, as: $('constants.icons.phone') },
                                                    { $: 'Text', children: 'Call us on 05224 648525' },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        $: 'WrappedLink',
                                        props: {
                                            to: 'mailto:email@email.com',
                                            fontSize: 'inherit',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            marginRight: { lg: 6 },
                                            _hover: {
                                                color: $('constants.colors.primary'),
                                            },
                                        },
                                        children: [
                                            {
                                                $: 'Stack',
                                                props: {
                                                    direction: 'row',
                                                    align: 'center',
                                                    spacing: '11px',
                                                },
                                                children: [
                                                    { component: Icon, as: $('constants.icons.email') },
                                                    { $: 'Text', children: 'or email us directly' },
                                                ],
                                            },
                                        ],
                                    }
                                ],
                            },
                        ],
                    },
                },
                
                // {
                //     $: 'WrappedLink',
                //     props: {
                //         position: 'relative',
                //         display: 'block',
                //         h: '240px',
                //         role: 'group',
                //         _after: {
                //             content: '""',
                //             position: 'absolute',
                //             top: 0,
                //             left: 0,
                //             w: '100%',
                //             h: '100%',
                //             bg: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                //             opacity: 1,
                //             zIndex: 2,
                //         },
                //         _hover: {
                //             _after: {
                //                 opacity: 0.6,
                //                 transition: 'background 0.4s cubic-bezier(.17,.67,.83,.67)',
                //             },
                //         },
                //     },
                // },
            ],
        },
    ],
}